export enum OfferProductSolutionType {
    UNKNOWN = -1,
    COMMUNITY = 5,
    AI_CONTENT = 6,
    WRITING_STYLE = 8,
    SEO_CLUSTER = 10,
    SEO_AUDIT = 11,
    OPTIMIZATION_CONTENT = 12,
    BRIEF_CONTENT = 13,
    SEO_PAGE_TRACKING = 14,
    SEO_SEARCH_KEYWORDS = 15,
    IMAGES_ALT_GENERATION = 17,
    IMAGES_OPTIMIZATION = 18,
    OPTIMIZATION_PRODUCTS_OR_CATEGORIES = 19,
    SEO_BACKLINK_EVALUATION = 20,
    SEO_BACKLINK_ANALYSIS = 21,
    SEO_BACKLINKS = 22,
    SEO_COMPETITORS = 23,
    SEO_BACKLINK_CAMPAIGN = 24,
    LLM_PROMPTS = 25,
    INDEXATION = 26,
    SEO_COMPETITORS_ANALYZE = 27,
    REVIEWS_TOPICS = 28,
    USERS = 29,
    CANNIBALIZATION = 30,
    AGENCY = 31,
}